// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"4708": "7366687c","5005": "9303d1ce","7057": "f6660550","8448": "8f0b63be","8966": "e505230b","9849": "3450bd81",}[chunkId] + ".css"
}